module.exports = __webpack_public_path__ + "static/media/progger1.e33171c2.png";